import { useQuery } from "@tanstack/react-query";
import { ssoApi } from "@repo/api";
import { ssoQueryKeys } from "../queryKeys";

export const useSpMetadata = () => {
  return useQuery({
    queryKey: ssoQueryKeys.spMetadata,
    queryFn: () => ssoApi.getSpMetadata(),
  });
};
